import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-account-icon',
    templateUrl: './account-icon.component.html',
    styleUrls: ['./account-icon.component.scss']
})
export class AccountIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
